/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  BulkDeleteDealReportsMutationRequest,
  BulkDeleteDealReportsMutationResponse,
  BulkDeleteDealReports400,
} from '../types/BulkDeleteDealReports'

function getBulkDeleteDealReportsUrl() {
  const res = {
    method: 'POST',
    url: `/api/v1/reports/deals/bulk/delete/` as const,
  }
  return res
}

/**
 * @description Handle bulk deletion of deals.
 * @summary Bulk delete deals from the deal-reports table
 * {@link /api/v1/reports/deals/bulk/delete/}
 */
export async function bulkDeleteDealReports(
  data?: BulkDeleteDealReportsMutationRequest,
  config: Partial<RequestConfig<BulkDeleteDealReportsMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    BulkDeleteDealReportsMutationResponse,
    ResponseErrorConfig<BulkDeleteDealReports400>,
    BulkDeleteDealReportsMutationRequest
  >({
    method: 'POST',
    url: getBulkDeleteDealReportsUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  })
  return res.data
}
